/**
 * Sektion-SCO-Model
 * @class service_v3sStructureSco
 * @memberOf v3sWbtPlayerApp:model
 * @extends v3sWbtPlayerApp:model.service_v3sSco
 */

angular.module('v3sWbtPlayerApp').factory('v3sStructureSco', ["v3sItem", "v3sSco", "v3sLog", "v3sBrowserInfoService", function (v3sItem, v3sSco, v3sLog, v3sBrowserInfoService) {

    // instantiate the sco object
    var v3sStructureSco = function (data) {
        // use the original item object constructor
        v3sSco.apply(this, arguments);

        this.trackable = false;
        this.treeChildren = [];
        data.hiddenItem = true;

        if (!!data.path) {
            var item = new v3sItem(data);
            item.parent = this;
            this.children.push(item);
        }
    };

    // use the original v3sSco prototype
    v3sStructureSco.prototype = new v3sSco();

    v3sStructureSco.prototype.updateTrackableStatus = function () {
        this.trackable = this.getChildrenForUpdate().length > 0;
    };

    v3sStructureSco.prototype.update = function () {
        this.updateTrackableStatus();
        return v3sSco.prototype.update.call(this);
    };

    v3sStructureSco.prototype.getChildren = function () {
        return this.treeChildren;
    };

    v3sStructureSco.prototype.setTreeChildren = function (treeChildren) {
        if (!!treeChildren) {
            this.treeChildren = treeChildren;
            this.update();
        } else if (!this.children || this.children.length == 0) {
            v3sLog.error("general.nofileonstructurescoerror", null, { value: this.title });
        }
    };

    v3sStructureSco.prototype.getProgress = function (withoutTreeChildren) {
        var progress = { completed: 0, count: 0 };

        if (!withoutTreeChildren) {
            progress = v3sSco.prototype.getProgress.call(this, withoutTreeChildren);
        }

        return progress;
    };

    v3sStructureSco.prototype.isVisible = function () {
        var visible = this.visible !== false;

        if (visible && this.parent !== null) {
            visible = this.parent.isVisible();
        }

        if (visible && this.treeChildren.length == 0) {
            if (v3sBrowserInfoService.isResponsiveView()) {
                visible = !!this.pathMobile;
            } else {
                visible = !!this.path;
            }
        }

        return visible;
    };

    v3sStructureSco.prototype.getExerciseStatistic = function () {
        var statisticData = { count: 0, correct: 0, wrong: 0, score: 0 };

        angular.forEach(this.getChildren(), function (child) {
            var childStatistic = child.getExerciseStatistic();
            statisticData.count += childStatistic.count;
            statisticData.correct += childStatistic.correct;
            statisticData.wrong += childStatistic.wrong;
        });

        statisticData.score = Math.round(statisticData.correct / statisticData.count * 100);

        return statisticData;
    };

    v3sStructureSco.prototype.getGlobalScormData = function (data) {
        var excludeFilter = [this.ScormDataEnum.STATUS, this.ScormDataEnum.SCORE, this.ScormDataEnum.TRACKABLE];
        v3sItem.prototype.getGlobalScormData.call(this, data, excludeFilter);
    };

    return v3sStructureSco;
}]);